import * as React from 'react';
import { Icon } from '@grandvisionhq/icons';

const Navigation = ({ classNames , step , route , handleClick , index , isLoggedIn , isDisabled =false  })=>/*#__PURE__*/ React.createElement("button", {
        className: classNames,
        key: route.label.toLowerCase(),
        onClick: ()=>handleClick(step)
        ,
        disabled: isDisabled
    }, /*#__PURE__*/ React.createElement(Icon, {
        name: "checkmark",
        className: "checkout-nav-step__icon"
    }), /*#__PURE__*/ React.createElement("span", {
        className: "checkout-nav-step__number"
    }, index + 1), /*#__PURE__*/ React.createElement("span", {
        className: "checkout-nav-step__name"
    }, route.loggedInLabel && isLoggedIn ? route.loggedInLabel : route.label))
;

export { Navigation };
//# sourceMappingURL=Navigation.js.map
